import connect from 'app/store/utils/saga/connect';
import * as showApply from './sagas/showApply';

export default connect([
  showApply,
]);
